
if ('performance' in window == false) {
  window.performance = {}
}

Date.now = (Date.now || function () { // thanks IE8
  return new Date().getTime()
})

if ('now' in window.performance == false) {
  var nowOffset = Date.now()

  if (performance.timing && performance.timing.navigationStart) {
    nowOffset = performance.timing.navigationStart
  }

  window.performance.now = function now () {
    return Date.now() - nowOffset
  }
}

class RAF {
  constructor () {
    this.funcs = {}
    this.lastPass = {}
    this.framerates = {}
    this.dt = Infinity
    this.timeElapsed = 0
    this.dictonary = []
    this.last = performance.now()
    this.initTime = performance.now()
    this.init()
  }

  suscribe (id, func, framerate = null) {
    this.dictonary.push(id)
    this.funcs[id] = func
    this.lastPass[id] = Date.now()

    if (framerate !== null) {
      this.framerates[id] = 1 / framerate
    } else {
      this.framerates[id] = framerate
      // this.framerates[id] = framerate
    }
  }

  unsuscribe (id) {
    if (this.funcs[id]) {
      this.dictonary.splice(this.dictonary.indexOf(id), 1)
      delete this.funcs[id]
    }
  }

  init () {
    this.update = this.update.bind(this)
    this.update()
  }

  update () {
    requestAnimationFrame(this.update)

    this.dt = performance.now() - this.last
    this.timeElapsed += this.dt

    let now = Date.now()
    for (let i = 0; i < this.dictonary.length; i++) {
      if (this.framerates[this.dictonary[i]] !== null && (now - this.lastPass[this.dictonary[i]]) < (this.framerates[this.dictonary[i]] * 1000)) {
        continue
      }
      if (typeof this.funcs[this.dictonary[i]] === 'function') {
        this.lastPass[this.dictonary[i]] = now
        this.funcs[this.dictonary[i]]()
      }
    }

    this.last = performance.now()
  }
}
const out = new RAF()
export default out
